module.exports = __webpack_public_path__ + "media/images/wedding/top/reason2-1a6326ce4cf20fa378d311cd5d0f6174.jpg";